import cn from 'classnames';
import Svg from 'react-inlinesvg';

import style from './CommonButton.module.scss';

export const CommonButton = ({ className, handleFunction, text, icon }) => {
  return (
    <button className={cn(style.button, className)} onClick={handleFunction}>
      <span className={style.text}>{text}</span>
      {icon && (
        <div className={style.iconBox}>
          <Svg src={icon.src} className={style.icon} />
        </div>
      )}
    </button>
  );
};
